/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const FileData: core.serialization.ObjectSchema<serializers.FileData.Raw, Truvity.FileData> =
    core.serialization.object({
        filename: core.serialization.string().optional(),
        id: core.serialization.string().optional(),
    });

export declare namespace FileData {
    export interface Raw {
        filename?: string | null;
        id?: string | null;
    }
}
